export interface ValidateHelpProps {
  help?: string;
  showValidateHelp?: boolean;
}

export function ValidateHelp({ help, showValidateHelp = true }: ValidateHelpProps) {
  if (!help || showValidateHelp === false) return null;
  return (
    <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4 }}>{help}</div>
  );
}
